import React, { ReactElement } from "react";
import { ReactComponent as ChevronRightIcon } from "images/icons/chevron-right.svg";

export type Breadcrumb = {
  key: string;
  title: string;
  onBreadcrumbClick?: (e: React.MouseEvent) => void;
}

export const Breadcrumbs = ({ leadingElement, breadcrumbs, onAllClick }: { leadingElement?: ReactElement; breadcrumbs: Breadcrumb[]; onAllClick: () => void }) => {
  const labels = breadcrumbs.map(breadcrumb => {
    const clickHandler = breadcrumb.onBreadcrumbClick

    if (clickHandler) {
      const onClick = (e: React.MouseEvent) => {
        e.preventDefault();

        clickHandler(e);
      }

      return <a key={breadcrumb.key} onClick={onClick}>{breadcrumb.title}</a>;
    } else {
      return <span key={breadcrumb.key}>{breadcrumb.title}</span>;
    }
  });

  const elements = labels.flatMap((label, index, array) =>
    array.length - 1 === index
      ? [label]
      : [label, <ChevronRightIcon key={`chevron-${label.key}`} className="icon streamline-icon"/>]
  )

  return <div className="breadcrumbs is-medium-text">
    {leadingElement}
    <a onClick={onAllClick}>All products</a>
    {elements.length > 0 ? <ChevronRightIcon className="icon streamline-icon"/> : null}
    {elements}
  </div>
}
